import React from 'react'
import { motion } from 'framer-motion'
import aboutData from '../data/about.json'

const AboutPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-white text-gray-900 dark:bg-custom-dark dark:text-gray-100 transition-colors">

      {/* Hero */}
      <motion.section
        className="pt-28 pb-12 px-4 sm:px-6 lg:px-8 text-center"
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
      >
        <div className="mx-auto max-w-5xl">
          <h1 className="font-display font-bold text-[clamp(2.5rem,6vw,4.5rem)] leading-tight">
            {aboutData.title}
          </h1>
        </div>
      </motion.section>

      {/* Content */}
      <section className="px-4 sm:px-6 lg:px-8 pb-20">
        <div className="mx-auto max-w-4xl space-y-10">
          
          {/* About Section */}
          <motion.div
            className="rounded-2xl shadow-xl p-6 sm:p-8 md:p-12"
            style={{ backgroundColor: '#252527' }}
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.15 }}
          >
            {/* Image */}
            {aboutData.backgroundImage && (
              <div className="mb-8 overflow-hidden rounded-xl">
                <img
                  src={aboutData.backgroundImage}
                  alt="About background"
                  loading="lazy"
                  className="w-full h-auto object-contain"
                />
              </div>
            )}

            {/* Description */}
            <div className="prose prose-lg prose-invert max-w-none">
              <p className="whitespace-pre-line leading-relaxed text-gray-300">
                {aboutData.description}
              </p>
            </div>
          </motion.div>

          {/* Contact Info Grid */}
          <motion.div
            className="grid md:grid-cols-3 gap-6"
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3 }}
          >
            {/* Location */}
            {aboutData.location && (
              <div className="rounded-xl p-6 border border-gray-700/50" style={{ backgroundColor: '#252527' }}>
                <div className="flex flex-col items-center text-center gap-3">
                  <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center">
                    <span className="material-symbols-outlined text-primary text-2xl">
                      location_on
                    </span>
                  </div>
                  <p className="text-gray-300 leading-relaxed text-sm">
                    {aboutData.location}
                  </p>
                </div>
              </div>
            )}

            {/* Contact */}
            <div className="rounded-xl p-6 border border-gray-700/50" style={{ backgroundColor: '#252527' }}>
              <div className="flex flex-col items-center text-center gap-3">
                <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center">
                  <span className="material-symbols-outlined text-primary text-2xl">
                    phone
                  </span>
                </div>
                <a href="tel:+17325816834" className="text-gray-300 hover:text-primary transition-colors font-medium">
                  +1 (732) 581-6834
                </a>
              </div>
            </div>

            {/* Business Hours */}
            {aboutData.hours && aboutData.hours.length > 0 && (
              <div className="rounded-xl p-6 border border-gray-700/50" style={{ backgroundColor: '#252527' }}>
                <div className="flex flex-col items-center text-center gap-3">
                  <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center">
                    <span className="material-symbols-outlined text-primary text-2xl">
                      schedule
                    </span>
                  </div>
                  <div className="space-y-1.5">
                    {aboutData.hours.map((hour: any, index: number) => (
                      <div key={index} className="flex justify-between text-xs gap-4 w-full">
                        <span className="text-gray-400">{hour.days}</span>
                        <span className="text-gray-300 font-medium">{hour.time}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}
          </motion.div>

        </div>
      </section>
    </div>
  )
}

export default AboutPage
